import { createApp } from "vue";
import { createPinia } from "pinia";

import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";

import "primeicons/primeicons.css";
import "@/assets/main.css";

import App from "@/App.vue";
import { router } from "@/router";
import { i18n } from "@/i18n";

const app = createApp(App);

app.use(createPinia());
app.use(i18n);
app.use(router);

app.use(PrimeVue, {
  license: "eyJpZCI6Ijg4MGJjZjhlLWRiMDktNGZkNS05MzEzLWE0NzE1NDQ3ZTRkMSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODQ1NjIxNDYsImV4cCI6MTgxNjA5ODE0Nn0.ZyPB9x4TV31nPKN0uB9PI63VC-hOQ4mgApbF2PAzTTdRCJSRcSH5qksfUW0GCp8mYvXlTggiagf0OnHaC2dxBA",
  theme: {
    preset: Aura,
    options: {
      // Matches the class toggled by the theme store and pre-applied in index.html.
      darkModeSelector: ".smibo-dark",
      // Keep PrimeVue's generated styles ahead of our own layer so app CSS can override them.
      cssLayer: {
        name: "primevue",
        order: "theme, base, primevue, smibo",
      },
    },
  },
  ripple: true,
});

app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);

app.mount("#app");

